/* External */
import { useEffect, useState } from 'react';
import addSeconds from 'date-fns/addSeconds';
import { useDispatch } from 'react-redux';

/* Utils */
import useRequestAndDelete from './useRequestAndDelete';
import useCurrentAndNextSchedules from './useCurrentAndNextSchedules';
import { STATUS_TYPES } from '../utils/constants';
import { scheduleFetchChannelSchedules } from '../storage/channels';

export default function useCurrentAndNextSchedulesAndFetch(channel, numberOfSchedules) {
  const currentAndNextSchedules = useCurrentAndNextSchedules(channel, numberOfSchedules);
  const { channelId, sourceProvider } = channel || {};
  const [requestId, setRequestId] = useState(undefined);

  const request = useRequestAndDelete(requestId);
  const dispatch = useDispatch();

  const isFetching = request?.status === STATUS_TYPES.INIT_STATE;

  useEffect(() => {
    if (
      channelId && (
        !currentAndNextSchedules?.size
        || (currentAndNextSchedules?.size > 0 && currentAndNextSchedules?.size < numberOfSchedules)
      )
    ) {
      let fromDatetime;
      if (currentAndNextSchedules?.size > 0) {
        const lastSchedule = currentAndNextSchedules.last();
        // We use fromDatetime as the endTime of last loaded schedule for this channel
        // and we add 1 second to avoid that last loaded schedule to be returned in response
        fromDatetime = addSeconds(lastSchedule.endTime, 1);
      }
      const action = scheduleFetchChannelSchedules({
        channelIdOrIds: channelId,
        schedulesForChannel:
          // Decrease the numberOfSchedules to request by the size of the schedules we already have
          numberOfSchedules && (numberOfSchedules - (currentAndNextSchedules?.size || 0)),
        fromDatetime,
        sourceProvider,
      });
      setRequestId(action.requestId);
      dispatch(action);
    }
  }, [dispatch, currentAndNextSchedules, numberOfSchedules, channelId, sourceProvider]);

  return {
    currentAndNextSchedules,
    isFetching,
  };
}
